import { ReactNode } from "react";

import { SubChildCategory } from "../../../categories.types";
import { IndelibleCategoryMessage } from "../../IndelibleCategoryMessage";

const ModalFooter = ({
  renderDeleteCategory,
  isEditableCategoryFetching,
  editableCategory
}: {
  renderDeleteCategory: ReactNode;
  isEditableCategoryFetching: boolean;
  editableCategory?: SubChildCategory;
}) => {
  if (isEditableCategoryFetching) {
    return null;
  }

  if (editableCategory?.isValidToDelete === false) {
    return <IndelibleCategoryMessage />;
  }

  return renderDeleteCategory;
};

export default ModalFooter;
